import { Widget } from '@kanda-libs/ks-component-ts';

import AddExpenseItemButton from './AddExpenseItemButton';
import ExpenseItem from './ExpenseItem';

const Expenses: React.FunctionComponent = function () {
  return (
    <Widget.CreditFinanceDetailsExpendituresArrayWrapper>
      {({ fields, arrayProps: { append, remove } }) => (
        <>
          {fields.map((field, index) => (
            <ExpenseItem key={field.id} index={index} remove={remove} />
          ))}
          <AddExpenseItemButton append={append} />
        </>
      )}
    </Widget.CreditFinanceDetailsExpendituresArrayWrapper>
  );
};

export default Expenses;
